import { render, staticRenderFns } from "./controlTransferCmp.vue?vue&type=template&id=ca81780c&"
import script from "./controlTransferCmp.vue?vue&type=script&lang=ts&"
export * from "./controlTransferCmp.vue?vue&type=script&lang=ts&"
import style0 from "./controlTransferCmp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports